import { useCallback, useState } from 'react'

/**
 * Progress state for a ZIP download request (0.0 – 1.0).
 *
 * The download server reports only a handful of values per request (max. 4 below
 * 200 MB, max. 10 above, plus 0.95 "packed" and 1.0 "done"), and polling answers
 * can overtake each other — so the value is only ever allowed to grow.
 * The bar itself animates the jumps (see `DownloadProgressBar`).
 */
export default function useDownloadProgress() {
  const [progress, setProgress] = useState(0)

  /** Never runs backwards; older backends omit the field, which counts as 0. */
  const reportProgress = useCallback((next: number | undefined | null) => {
    const value = typeof next === 'number' && isFinite(next) ? next : 0
    setProgress(prev => Math.max(prev, Math.min(1, Math.max(0, value))))
  }, [])

  const resetProgress = useCallback(() => setProgress(0), [])

  return { progress, reportProgress, resetProgress }
}
